import React, { useRef, useState } from 'react';
import { useResponsiveValueState } from '@saviynt/common';
import {
  ApplicationIcon,
  Box,
  Button,
  FooterActionBar,
  Icon,
  SidePanel,
  Typography,
} from '@saviynt/design-system';

import { type NodeData } from '../../features/Butterfly2-POC/Butterfly2Data';

import './IntegrationsSideCard.css';

interface ButterflyGraphSidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  selectedNode: NodeData | null;
}

/**
 * Integrations All tab page Side Card
 */
function IntegrationsSideCard({
  isOpen,
  onClose,
  selectedNode,
}: ButterflyGraphSidePanelProps) {
  const sidepanelRef = useRef(null);
  const [mediaQueryValue, setMediaQueryValue] = useState(0);

  const SCREEN_WIDTH_QUERIES = [
    { query: '(max-width: 833px)', value: 100, label: 'TabletMedium' },
  ];

  useResponsiveValueState(setMediaQueryValue, SCREEN_WIDTH_QUERIES);

  const tabletMediumQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === 'TabletMedium'
  );
  const isTabletMediumWidth = tabletMediumQuery?.value
    ? tabletMediumQuery.value <= mediaQueryValue
    : false;

  const layout = () => (
    <Box className='ButterflyGraphSidePanel-layoutWidth'>
      <Typography kind='h4'>
        {selectedNode?.appName ?? 'Unnamed App'}
      </Typography>
      <Typography kind='body2'>ID: {selectedNode?.id}</Typography>
      <Typography kind='body2'>Category: {selectedNode?.category}</Typography>
      <Typography kind='body2'>Status: {selectedNode?.status}</Typography>
    </Box>
  );

  const footer = () => (
    <FooterActionBar className='ButterflyGraphSidePanel-footer'>
      <Button kind='outlined' size='medium' onClick={onClose}>
        Close
      </Button>
      <Button kind='filled' size='medium' onClick={() => {}}>
        Configure
      </Button>
    </FooterActionBar>
  );

  return (
    <Box className='ButterflyGraphSidePanel-sidePanelWrapper'>
      <SidePanel
        ref={sidepanelRef}
        header={{
          title: selectedNode?.appName ?? 'App Details',
          description: selectedNode?.category ?? 'Unknown Category',
          headerIcon: selectedNode?.appName ? (
            <ApplicationIcon logo={selectedNode.appName} size='xxLarge' />
          ) : (
            <Icon kind='Applications' size='xxLarge' />
          ),
        }}
        layout={layout()}
        isOpen={isOpen}
        onClose={onClose}
        footer={footer()}
        isSidePanelNavigatingList={false}
        isTabletWidth={isTabletMediumWidth}
        className='ButterflyGraphSidePanel'
        layoutClassName='ButterflyGraphSidePanel-sidePanelLayout'
      />
    </Box>
  );
}

export default IntegrationsSideCard;
